export default {
  '': '',
  'invalid.phone': 'شماره تلفن وارد شده معتبر نیست',
  'phone.notChanged': 'قبلاً با همین شماره ثبت‌نام کرده‌اید',
  'phone.exists': 'شماره تلفن قبلاً در سامانه ثبت شده است',
  'phone.invalid': 'شماره تلفن وارد شده صحیح نیست',
  'secret.mismatch': 'کد وارد شده صحیح نیست',
  'invalid.token': 'کد وارد شده معتبر نیست',
  'invalid token : 1 wrong attempts': 'کد وارد شده معتبر نیست',
  'invalid token : 2 wrong attempts': 'کد وارد شده معتبر نیست',
  'invalid token : 3 wrong attempts': 'کد وارد شده معتبر نیست',
  'invalid token : 4 wrong attempts': 'کد وارد شده معتبر نیست',
  'invalid token : 5 wrong attempts': 'کد وارد شده معتبر نیست',
  requestError:
    'ارتباط با سرور دچار مشکل شده است. لطفاً اینترنت خود را چک کنید',
  'document.name.empty': 'نام فایل نمی‌تواند خالی باشد',
  'file.tooLarge': 'حجم این فایل از حد مجاز بیشتر است',
  'file.unavailable':
    'فایل انتخاب‌شده دیگر در دسترس نیست (ممکن است جابه‌جا یا حذف شده باشد). لطفاً دوباره آن را انتخاب کنید',
  unknownError:
    'خطای نامشخصی رخ داد، لطفاً دوباره تلاش کنید و درصورت عدم موفقیت با پشتیبانی تماس بگیرید',
  'providerFolder.dad.invalid': 'نمی‌توانید آیتم را به این پوشه منتقل کنید',
  'providerItem.dad.isInvalidFolder':
    'نمی‌توانید آیتم را به این پوشه منتقل کنید',
  'User Not Found': 'ایمیل و یا رمز عبور اشتباه است',
  'password.not.unique': 'رمز عبور و تکرار آن یکسان نیست',
  'captcha.invalid': 'لطفاً تایید کنید که ربات نیستید',
  'Invalid Email': 'لطفاً ایمیل را به طور صحیح وارد کنید',
  'Password Is Not Good': 'لطفاً پسورد را به طور صحیح وارد کنید',
  'User Exists': 'قبلاً با این ایمیل عضو شده‌اید',
  'login.invalid': 'ایمیل و یا رمز عبور اشتباه وارد شده است',
  'overlapping phases': 'بازه های انتخابی نباید با هم اشتراک داشته باشند',
  AuthenticationFailed: 'خطا در ورود. لطفا با پشتیبانی تماس بگیرید',
  'user.disabled': 'کاربر غیر فعال است',
  'user.blocked': 'حساب شما مسدود شده است لطفا با پشتیبانی تماس بگیرید',
  'user.deleted': 'حساب شما حذف شده است.',
  'invalid.ip': 'امکان ورد از این آدرس وجود ندارد',
  require2fa: 'لطفا از ورود دو مرحله ای استفاده کنید',
  'companyMember.exists': 'کاربر مورد نظر از کاربران موجود شرکت است',
  'userId.exists': 'کاربر مورد نظر از کاربران موجود پروژه است',
  'file.invalid': 'نوع فایل ارسالی نامعتبر است',
  'tag.parent.invalid': 'والد برچسب انتخابی نامعتبر است',
  'There Is No Company': 'شرکتی وجود ندارد',
  canNotViewInMobile: 'این نوع از فایل را نمی‌توان در موبایل مشاهده کرد',
  '403.unauthenticated': 'لطفاً دوباره وارد سیستم بشوید',
  '403.unauthorized': 'دسترسی لازم را ندارید',
  'question.tags.empty': 'برچسبی برای سؤال انتخاب نکرده‌اید',
  'reportField.name.required': 'عنوان فیلد برچسبی نمی‌تواند خالی باشد',
  'provider.invalid': 'شما دسترسی انجام این کار را ندارید',
  'instance.required': 'هویت کاربر را مشخص نکرده‌اید',
  'limit.user.hour':
    'به دلیل درخواست زیاد شماره‌ی شما تا یک ساعت آتی امکان دریافت پیام تایید را ندارد',
  'companyMember.isOwner': 'سازنده‌ی کمپانی نمی‌تواند خود را حذف کند',
  'invalid.text.length': 'تعداد کاراکترهای وارد شده بیشتر از حد مجاز می‌باشد',
  'invalid.text.format': 'نوع داده‌ی ورودی اشتباه می‌باشد',
  'response.duplicate': 'امکان پاسخ دوباره وجود ندارد',
  'effectiveDate.required': 'بازه‌ی زمانی انتخاب نشده است',
  'not.companyMember': 'کاربر عضو فعال مجموعه نیست',
  'limit.user.day':
    'به دلیل درخواست زیاد شماره‌ی شما تا ۲۴ ساعت امکان دریافت پیام تایید را ندارد',
  'user not found': 'کاربر پیدا نشد',
  'role.with.same.name.exists': 'سمتی با این نام وجود دارد',
  'parent.is.deleted': 'برچسب پدر حذف شده است.',
  'tag.exists.with.deleted.parent':
    'تگ مشابهی وجود دارد اما امکان بازگردانی آن به دلیل حذف پدر وجود ندارد',
  'file.already.exists': 'سند با این عنوان وجود دارد',
  'can.not.fill.for.this.period':
    'امکان ارسال برای دوباره در این بازه وجود ندارد',
  'class.has.time.conflicts.with.existing.classes':
    'این کلاس با کلاسهای موجود تداخل زمانی دارد',
};
